if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          dots: this.querySelectorAll('[data-slider-dot]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
          if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        }

        if (this.elements.dots?.length) {
          const ul = this.elements.viewer.querySelector('[id^="Slider-Gallery-"]');
          const slides = ul ? Array.from(ul.children) : [];
          this.elements.dots.forEach((dot) => {
            dot.addEventListener('click', () => {
              const idx = Number(dot.dataset.index || 0);
              const target = slides[idx];
              if (!target) return;
              ul.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
              this.setActiveMedia(target.dataset.mediaId, false);
            });
          });
        }
      }

      // onSlideChanged(event) {
      //   const mediaId = event.detail.currentElement.dataset.mediaId;

      //   if (this.elements.thumbnails) {
      //     const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      //     this.setActiveThumbnail(thumbnail);
      //   }

      //   this.setActiveDot(event.detail.currentElement);
      // }
      onSlideChanged(event) {
        const currentElement = event?.detail?.currentElement;

        if (!currentElement) {
          console.warn('currentElement is undefined', event);
          return;
        }

        const mediaId = currentElement.dataset?.mediaId;

        if (!mediaId) return;

        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }

        this.setActiveDot(currentElement);
      }

      setActiveMedia(mediaId, prepend, preventPageScroll = false) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (activeMedia.classList.contains('product__media-item--variant') && this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll('.thumbnail-list_item--variant')
            .forEach((item) => item.classList.remove('is-current-color'));
          this.elements.thumbnails
            .querySelector(`[data-target="${CSS.escape(mediaId)}"]`)
            ?.classList.add('is-current-color');
        }

        // Hidden color slides are swapped one-for-one, so recalculate the mobile
        // pages while keeping the original gallery count stable.
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (preventPageScroll) return;

          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      setActiveDot(activeMedia) {
        if (!this.elements.dots?.length) return;

        const ul = this.elements.viewer.querySelector('[id^="Slider-Gallery-"]');
        if (!ul) return;
        const slides = Array.from(ul.children);
        const index = slides.indexOf(activeMedia);
        if (index === -1) return;

        this.elements.dots.forEach((dot) => {
          dot.classList.toggle('slider-counter__link--active', Number(dot.dataset.index || 0) === index);
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        // Chỉ gán lại src khi ảnh đã tải xong (để kích hoạt onload từ cache).
        // Gán lại lúc ảnh đang tải dở sẽ HỦY request và tải lại từ đầu →
        // ảnh chính biến mất lâu ở lượt truy cập đầu tiên chưa có cache.
        if (image.complete) image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
